import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion, faHashtag } from '@fortawesome/free-solid-svg-icons';
import { Card } from '../components/UI/Card';
import { Modal } from '../components/UI/Modal';
import { CreateKreeda } from '../components/CreateWizard/CreateKreeda';
const Home = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedType, setSelectedType] = useState('');
    const quickActions = [
        {
            title: 'Create Quiz',
            description: 'Create engaging quizzes with multiple question types',
            icon: faQuestion,
            type: 'quiz',
        },
        {
            title: 'Create Crossword',
            description: 'Design interactive crossword puzzles',
            icon: faHashtag,
            type: 'crossword',
        },
        // {
        //   title: 'Create Survey',
        //   description: 'Gather feedback and insights',
        //   icon: faSquarePollVertical,
        //   type: 'survey',
        // },
    ];
    /**
     * Handles quick action card click
     * Opens the creation modal with the selected activity type
     */
    const handleQuickAction = (type) => {
        setSelectedType(type);
        setIsModalOpen(true);
    };
    /**
     * Handles modal close event
     * Resets the selected activity type and closes the modal
     */
    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedType('');
    };
    const trendingQuizzes = [
        {
            title: 'Mathematics Quiz',
            description: '10 questions • Created 2 days ago',
            plays: 150,
        },
        {
            title: 'Science Trivia',
            description: '15 questions • Created 3 days ago',
            plays: 120,
        },
    ];
    return (React.createElement("div", { className: "home-container" },
        React.createElement("section", { className: "welcome-section" },
            React.createElement("h1", null, "Welcome to Gyaan Kreeda"),
            React.createElement("p", null, "Create engaging quizzes, crosswords, and surveys")),
        React.createElement("section", { className: "quick-actions" },
            React.createElement("h2", null, "Quick Actions"),
            React.createElement("div", { className: "quick-actions-grid" }, quickActions.map((action, index) => (React.createElement("div", { key: index, className: "quick-action-card", onClick: () => handleQuickAction(action.type) },
                React.createElement("div", { className: "quick-action-icon" },
                    React.createElement(FontAwesomeIcon, { icon: action.icon })),
                React.createElement("h3", null, action.title),
                React.createElement("p", null, action.description)))))),
        React.createElement(Modal, { id: "create-kreeda", component: CreateKreeda, componentProps: {
                initialType: selectedType,
                skipTypeSelection: true,
            }, isOpen: isModalOpen, onClose: handleModalClose }),
        React.createElement("section", { className: "trending-section" },
            React.createElement("h2", null, "Trending Now"),
            React.createElement("div", { className: "trending-grid" }, trendingQuizzes.map((quiz, index) => (React.createElement(Card, { key: index, className: "trending-card" },
                React.createElement("div", { className: "trending-card-content" },
                    React.createElement("h3", null, quiz.title),
                    React.createElement("p", null, quiz.description),
                    React.createElement("div", { className: "trending-card-stats" },
                        React.createElement("span", null,
                            "\uD83D\uDC65 ",
                            quiz.plays,
                            " plays")))))))),
        React.createElement("section", { className: "recent-activity" },
            React.createElement("h2", null, "Recent Activity"),
            React.createElement("div", { className: "activity-list" },
                React.createElement(Card, { className: "activity-card" },
                    React.createElement("p", null, "No recent activity"))))));
};
export { Home };
